// extracted by mini-css-extract-plugin
export var active = "_gf-2";
export var recordingDot = "_gf-1";
export var recordingIndicator = "_gf-0";